<style>
    .list-preview-card{
        display: flex;
        min-height: 81px;
        border-radius: 5px;
        /*background-color: var(--card-background);*/
        overflow: hidden;
    }
    .list-preview-card .preview-image-container{
        width: 86px;
        position: relative;
        height: 100%;
    }
    .list-preview-card .preview-image{
        object-fit: cover;
        position: absolute;
        top: 0;
        bottom: 0;
        left: 0;
        right: 0;
        width: 100%;
        height: 100%;
    }
    .list-preview-card .list-preview-body{
        padding: 8px;
    }
    .list-preview-card.layout-card .preview-image-container{
        width: 100%;
        height: 100px;
    }
    .list-preview-card.layout-card .preview-image{
        object-fit: contain;
        background-color: white;
    }
</style>

<script>
    import {shopifyHelperMixin} from "../../mixins/shopifyHelperMixin";

    export default {
        props: ['list', 'layout'],
        data: function () {
            return {

            };
        },
        mixins: [shopifyHelperMixin],
        components: {

        },
        created: function () {

        },
        mounted: function () {
            var self = this;

        },
        computed: {
            image_url: function () {
                if(this.list.image_url){
                    return this.list.image_url;
                }
                if(this.list.items && this.list.items.length){
                    var item = this.list.items[0];
                    if(this.list.item_type === 'profile' && item.influencer){
                        return item.influencer._profile_image_url;
                    } else if(this.list.item_type === 'hashtag' && item._popular_media && item._popular_media.length){
                        return item._popular_media[0].image_url;
                    } else if(this.list.item_type === 'post' && item.image_url){
                        return item.image_url;
                    } 
                }
                if(this.list.item_type === 'product'){
                    if(this.list.first_images && this.list.first_images.length && this.list.first_images[0].url){
                        if(this.layout === 'card'){
                            return this.resizeImage(this.list.first_images[0].url, '_x400');
                        } else {
                            return this.resizeImage(this.list.first_images[0].url, '_x100');
                        }
                    }
                }
            },
            list_url: function () {
                return this.list.url;
            },
            name: function () {
                if(this.list.data_generated && this.list.data_generated.headline){
                    return this.list.data_generated.headline;
                }
                return this.list.custom_name || this.list.name;
            },
            author: function () {
                if(this.list.user){
                    if(this.list.user.username){
                        return '@' + this.list.user.username;
                    }
                    return this.list.user.full_name;
                }
                return 'ReachDog'
            },
            item_type_name: function(){
                var type = this.list.item_type;
                if(!type){
                    return;
                }
                if(type === 'product'){
                    return 'Product List';
                }
                var name = type.charAt(0).toUpperCase() + type.slice(1) + 's';
                return name;
            }
        },
        watch: {

        },
        methods: {

        },
        filters: {

        }
    };
</script>

<template>
    <a :href="list_url" class="list-preview-card text-reset" :class="[layout ? 'layout-' + layout : '']">
        <div>
            <div class="row no-gutters h-100">
                <div :class="[layout === 'card' ? 'col-12' : 'col-auto']" v-if="image_url">
                    <div class="preview-image-container">
                        <img class="preview-image lazyload" :data-src="image_url  + '?h=100'" width="86" height="81" alt="List Image">
                    </div>
                </div>
                <div class="col">
                    <div class="list-preview-body">
                        <div class="text-primary small mb-1">{{item_type_name}}</div>
                        <div class="style-body-bold mb-1">{{name}}</div>
                        <div class="text-subtle" v-if="list.updated_at">Updated {{formatDate(list.updated_at, 'MMMM D, YYYY h:mmA')}}</div>
                    </div>
                </div>
            </div>
        </div>
    </a>
</template>



// WEBPACK FOOTER //
// resources/views/rd/assets/js/v2/components/lists/listPreviewCard.vue